import { createFileRoute, redirect } from '@tanstack/react-router';
import {
  FEATURE_FLAGS,
  getFeatureFlagOutsideReact,
} from '../../../../../../lib/featureFlags';
import { latestSampleSetInterpretiveReportQueryOptions } from '../../../../../../services/queries';

export const Route = createFileRoute(
  '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/'
)({
  loader: async ({ context, params }) => {
    if (await getFeatureFlagOutsideReact(FEATURE_FLAGS.reportsTab)) {
      let latestReport = null;
      try {
        latestReport = await context.queryClient.fetchQuery(
          latestSampleSetInterpretiveReportQueryOptions(
            params.sampleSetId,
            context.auth.hasPermission
          )
        );
      } catch {
        // Preserve Samples as the safe landing page when reports are unavailable.
      }
      if (latestReport) {
        throw redirect({
          to: '/experiments/$sampleSetId/interpretations/$interpretationId',
          params: {
            sampleSetId: params.sampleSetId,
            interpretationId: latestReport.id,
          },
          replace: true,
        });
      }
    }

    throw redirect({
      to: '/experiments/$sampleSetId/samples',
      params: { sampleSetId: params.sampleSetId },
      replace: true,
    });
  },
});
